<template>
  <div class="col-md-10" v-if="barcode && status != null">
    <div
      class="wrapper-upload-form"
      v-if="action == 'ready' && status.active == 0"
    >
      <label class="mx-5">
        <h4>Target SKUs (counted toward progress)</h4>
      </label>

      <button
        type="button"
        class="btn btn-primary btn-round"
        :disabled="disabled"
        @click="setAction('editing')"
      >
        Edit
      </button>
    </div>
    <div
      class="wrapper-upload-form"
      v-else-if="action == 'editing' && status.active == 0"
    >
      <label class="mx-5">
        <h4>Target SKUs (counted toward progress)</h4>
      </label>
      <div>
        <button
          type="button"
          class="btn btn-round btn-primary mx-10"
          @click="toggleSelectAll"
        >
          {{ skuSelected.length < skus.length ? "Select All" : "Deselect All" }}
        </button>
        <button
          type="button"
          class="btn btn-round btn-primary mx-10"
          @click="handleVerify"
          :disabled="disabled"
        >
          Verify
        </button>
        <button
          type="button"
          class="btn btn-round btn-default"
          @click="handleCancel"
          :disabled="disabled"
        >
          Cancel
        </button>
      </div>
    </div>
    <div class="wrapper-upload-form" v-else-if="status.active == 1">
      <label class="mx-5">
        <h4>Target SKUs (counted toward progress)</h4>
      </label>

      <label class="label-blue" v-if="status.state == 'verify'">
        Verifying change
      </label>

      <label class="label-blue" v-else-if="status.state == 'done-verify'">
        Click to commit change
      </label>

      <div v-if="status.state == 'verify'">
        <button type="button" class="btn btn-round btn-primary mx-10" disabled>
          Commit
        </button>
        <button type="button" class="btn btn-round btn-default" disabled>
          Cancel
        </button>
      </div>
      <div v-else-if="status.state == 'done-verify'">
        <button
          type="button"
          class="btn btn-round btn-primary mx-10"
          @click="getResult"
          :disabled="disabled"
        >
          Commit
        </button>
        <button
          type="button"
          class="btn btn-round btn-default"
          @click="handleCancel"
          :disabled="disabled"
        >
          Cancel
        </button>
      </div>
    </div>

    <Selectize
      multiple
      :disabled="!canEdit"
      v-model="skuSelected"
      :settings="selectizeSetting"
    >
      <option v-for="(sku, index) in skus" :key="index" :value="sku.PRO_CODE">
        {{ sku.PRO_NAME_EN + " - " + sku.PRO_CODE }}
      </option>
    </Selectize>

    <modal name="try-update-sku-modal" :width="900" height="auto">
      <TryUploadUserTargetModal
        :campaign="campaign"
        :result="result"
        @confirm="confirmUpdate"
        name="try-update-sku-modal"
      />
    </modal>
  </div>
</template>

<script>
import { progressBarService } from "@/api/client";
import Selectize from "vue2-selectize";
import TryUploadUserTargetModal from "./TryUploadUserTargetModal.vue";

export default {
  props: ["campaign"],

  components: {
    Selectize,
    TryUploadUserTargetModal,
  },

  data() {
    return {
      skus: [],
      status: null,
      result: null,
      barcode: null,
      skuSelected: [],
      action: "ready",
      pullingId: null,
      selectizeSetting: {
        selected: [],
        plugins: ["remove_button"],
        // create: this.add,
      },
    };
  },

  computed: {
    disabled() {
      return ["archived", "end", "aborted"].includes(this.campaign.status);
    },
    canEdit() {
      return (
        this.action == "editing" &&
        !["archived", "end", "aborted"].includes(this.campaign.status)
      );
    },
  },

  watch: {
    status(n) {
      if (
        n.active === 1 &&
        n.type == "sku" &&
        n.state == "verify" &&
        this.pullingId === null
      ) {
        this.startPullingStatus();
        return;
      }

      if (
        n.active === 1 &&
        n.type == "sku" &&
        n.state == "execute" &&
        this.pullingId === null
      ) {
        this.startPullingStatus();
        return;
      }

      if (n.active === 1 && n.type == "sku" && n.state == "done-execute") {
        this.setAction("ready");
        this.getUploadStatus();
        return;
      }

      if (n.active === 0) {
        this.setAction("ready");
        this.stopPullingStatus();
        return;
      }
    },
  },

  methods: {
    setAction(action) {
      this.action = action;
    },

    async handleCancel() {
      if (this.status.active === 1) {
        await progressBarService.tryCancelUpdateSKU(
          this.campaign.id,
          "barcode"
        );
        this.$notify("Cancel success");
        this.getUploadStatus();
      }

      this.setAction("ready");
      this.skuSelected = this.barcode.sku;
    },

    async handleVerify() {
      if (this.barcode.sku.length === 0 && this.skuSelected.length <= 0) {
        return;
      }

      this.campaign.status == "draft"
        ? await this.update()
        : await this.tryUpdate();

      await this.getUploadStatus();
      this.barcode.sku = this.skuSelected;
    },

    async update() {
      try {
        const form = { sku: this.skuSelected };

        await progressBarService.updateSKU(this.campaign.id, "barcode", form);

        this.$notify(`Target SKUs Updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Target SKUs update error.`);
      }
    },

    async tryUpdate() {
      try {
        const form = { sku: this.skuSelected };

        const result = await progressBarService.tryUpdateSKU(
          this.campaign.id,
          "barcode",
          form
        );

        if (result.error) {
          this.cancelProcess();
          this.$dialogs.alert(result.error);
        }
      } catch (error) {
        console.error(error);
        this.getUploadStatus();
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Target SKUs update error.`);
      }
    },

    async getResult() {
      try {
        this.result = await progressBarService.tryUpdateSKUResult(
          this.campaign.id,
          "barcode"
        );

        this.$modal.show(`try-update-sku-modal`);
      } catch (error) {
        console.error(error);
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Target SKUs update error.`);
      }
    },

    async confirmUpdate() {
      try {
        await progressBarService.tryConfirmUpdateSKU(
          this.campaign.id,
          "barcode"
        );

        this.$notify("Confirm success");
        this.getUploadStatus();
        this.$emit("updated");
      } catch (error) {
        console.error(error);
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$notify("Try upload error");
      }
    },

    async getSKUList() {
      this.skus = await progressBarService.getSKUList();
    },

    toggleSelectAll() {
      if (this.skuSelected.length < this.skus.length) {
        this.skuSelected = this.skus.map((o) => o.PRO_CODE);
      } else {
        this.skuSelected = [];
      }
    },

    async getUploadStatus() {
      this.status = await progressBarService.getUploadStatus(this.campaign.id);
    },

    startPullingStatus() {
      this.pullingId = setInterval(this.getUploadStatus, 5000);
    },

    stopPullingStatus() {
      clearInterval(this.pullingId);
      this.pullingId = null;
    },

    add(sku) {
      return {
        value: sku,
        text: sku,
      };
    },
  },

  beforeDestroy() {
    this.stopPullingStatus();
  },

  mounted() {
    this.barcode = this.campaign.barcode;
    this.skuSelected = this.barcode.sku;
  },

  async created() {
    await this.getSKUList();
    await this.getUploadStatus();
  },
};
</script>

<style lang="scss" scoped>
.wrapper-upload-form {
  display: flex;
  margin: 2em auto;
  align-items: center;
  justify-content: space-between;

  .label-blue {
    color: #2b69bb;
    font-weight: 500;
  }
}
</style>
